// Events
import { MODAL_TOGGLE, PRODUCT_FORM_UPDATE_VARIANT, STICKY_FOOTER_TOGGLE_SECTION } from 'events';
import { component } from 'picoapp';

export default component((node, ctx) => {
  const { relProducts, optionsModal, optionsModalSection, singleSizeProduct, suitProduct } =
    node.dataset;

  const relatedProducts = [].concat(relProducts.split(',') || []);
  const updatedProducts = relatedProducts.reduce((obj, handle) => ({ [handle]: null, ...obj }), {});

  let variantsNotSelected = singleSizeProduct === 'false';

  const update = (state, updatedProductHandle) => {
    if (!relatedProducts.includes(updatedProductHandle)) return;

    const available = state?.selectedVariant?.available ?? false;

    updatedProducts[updatedProductHandle] = available;

    variantsNotSelected = relatedProducts.some((handle) => updatedProducts[handle] === null);
    const variantsAvailable = relatedProducts.every((handle) => updatedProducts[handle] === true);

    if (variantsNotSelected) {
      node.disabled = true;
      node.classList.add('no-variant');
      node.classList.remove('sold-out', 'available');
    } else if (variantsAvailable) {
      node.disabled = false;
      node.classList.add('available');
      node.classList.remove('sold-out', 'no-variant');
    } else {
      node.disabled = node.type === 'submit';
      node.classList.remove('available', 'no-variant');
      node.classList.add('sold-out');
    }
  };

  node.addEventListener('click', (e) => {
    if (!variantsNotSelected || suitProduct === 'true') return;

    e.preventDefault();

    if (optionsModal) {
      ctx.emit(MODAL_TOGGLE, null, {
        id: optionsModal,
        props: {
          modalBox: optionsModalSection,
          modalSection: optionsModalSection,
        },
      });
    } else {
      ctx.emit(STICKY_FOOTER_TOGGLE_SECTION, null, 'sizes');
    }
  });

  ctx.on(PRODUCT_FORM_UPDATE_VARIANT, update);
});
